import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { jsFn } from '@/utils/js-fn'

// i18n
import en from './lang/en.json'
import tw from './lang/tw.json'
import cn from './lang/cn.json'
import jp from './lang/jp.json'
import kr from './lang/kr.json'
import userRegistV2 from './lang/userRegistV2'
import htLogin from './lang/htLogin'

Vue.use(VueI18n)

// 預設抓取瀏覽器的語系
var pageLang = jsFn.isEmpty(localStorage.lang) ? navigator.language.toLowerCase() : localStorage.lang

// 預設為英文版
switch (pageLang) {
  case 'zh-tw':
  case 'zh-cn':
  case 'ja-jp':
  case 'ko-kr':
  break
  default:
    pageLang = 'en-us'
  break
}

if(jsFn.isCN()) {
  pageLang = 'zh-cn'
}

localStorage.lang = pageLang

const i18n = new VueI18n({
  locale: pageLang,
  messages: {
    'zh-tw': { ...tw, ...userRegistV2['zh-tw'], ...htLogin['zh-tw'] },
    'zh-cn': { ...cn, ...userRegistV2['zh-cn'], ...htLogin['zh-cn'] },
    'en-us': { ...en, ...userRegistV2['en-us'], ...htLogin['en-us'] },
    'ja-jp': { ...jp, ...userRegistV2['ja-jp'], ...htLogin['ja-jp'] },
    'ko-kr': { ...kr, ...userRegistV2['ko-kr'], ...htLogin['ko-kr'] }
  }
})

export default i18n
